import { History } from "lucide-react";
import { fmtDateTime } from "@/lib/constants";
import { fieldLabels, formatHistoryValue } from "./utils";

export default function EditHistorySection({ history, show, onToggle }) {
  return (
    <div className="border-t border-slate-200 pt-3">
      <button
        type="button"
        data-testid="edit-history-toggle"
        onClick={onToggle}
        className="inline-flex items-center gap-1.5 text-xs uppercase tracking-wider font-semibold text-slate-600 hover:text-[#0B1D3A]"
      >
        <History size={13} />
        Edit History ({history.length})
        <span className="text-slate-400">{show ? "▲" : "▼"}</span>
      </button>
      {show && (
        <div className="mt-3 max-h-52 overflow-y-auto border border-slate-200 bg-slate-50 divide-y divide-slate-200" data-testid="edit-history-list">
          {history.length === 0 && (
            <div className="px-3 py-3 text-xs text-slate-500">No edits recorded yet.</div>
          )}
          {history.map((h, idx) => (
            <div key={h.at || idx} className="px-3 py-2 text-xs">
              <div className="flex justify-between items-baseline mb-1">
                <span className="font-semibold text-[#0B1D3A]">{h.by_name}</span>
                <span className="text-slate-500 tabular-nums">{fmtDateTime(h.at)}</span>
              </div>
              <ul className="pl-3 space-y-0.5">
                {(h.changes || []).map((c, i) => (
                  <li key={`${c.field}-${i}`} className="text-slate-700">
                    <span className="font-medium">{fieldLabels[c.field] || c.field}:</span>{" "}
                    <span className="text-rose-600 line-through">{formatHistoryValue(c.field, c.old)}</span>
                    {" → "}
                    <span className="text-emerald-700 font-semibold">{formatHistoryValue(c.field, c.new)}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
